import * as React from 'react';
import { createViewConfig, view } from '@sail/engine';
import { cancel } from '@sail/icons/react/Icon';
import { Action } from '../Action';
import { Icon } from '../Icon';
import { actionButton } from '../../utilStyles/ActionButton';
import { css } from '../../css';
export const PopoverHeaderConfig = createViewConfig({
    props: {},
    name: 'PopoverHeader'
});
export const PopoverHeader = PopoverHeaderConfig.createView(({ title, onClose, ...props })=>{
    return /*#__PURE__*/ React.createElement(view.div, {
        css: [
            css({
                stack: 'x',
                paddingX: 'space.250',
                paddingTop: 'medium',
                paddingBottom: 'space.0'
            }),
            title ? css({
                distribute: 'space-between',
                alignX: 'start'
            }) : css({
                distribute: 'packed',
                alignX: 'end'
            })
        ],
        ...props
    }, title ? /*#__PURE__*/ React.createElement(view.h2, {
        css: {
            margin: 'space.0',
            color: 'emphasized',
            font: 'heading.medium'
        }
    }, title) : null, /*#__PURE__*/ React.createElement(Action, {
        // TODO: SAIL-3215 no hardcoded strings
        "aria-label": "Close",
        onPress: onClose,
        uses: actionButton,
        css: {
            bleedRight: 'small'
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: cancel
    })));
});

//# sourceMappingURL=PopoverHeader.js.map